<template>
  <div class="admin-dashboard" >
    <HeaderBar :ranges="ranges" @change-range="onChangeRange" @refresh="refresh" :statistic="statistic" :showButtons="true" :title="'Статистика'"/>
    <main class="admin-dashboard__container">
      <KpiRow :stats="stats" :currentStatistic="currentStatistic"/>
      

      <section class="charts">
        <ChartCardWrapper title="Динамика сессий">
          <LineChart :currentRaw="currentRange" :rawData="currentStatistic" @point-click="onPointClick" />
          <div class="chart-meta">
            <div>Среднее: <strong>{{ formatNumber(currentStatistic?.average_sessions_per_day) }}</strong> в день</div>
            <div>Пиковый день: <strong>{{ currentStatistic?.peak_day?.sessions }}</strong></div>
          </div>
        </ChartCardWrapper>

        <ChartCardWrapper title="Источники сессий" small>
          <PieChart :items="stats.sources" :currentStatistic="currentStatistic"/>
          <SourcesList :currentStatistic="currentStatistic" />
        </ChartCardWrapper>
      </section>

      <RecentLeadsTable :currentRangeTitle="getRangeTitle(currentRange)" :leads="recentLeads" @open-lead="openLead" :requests="requests"/>
    </main>

    <FooterBar :lastUpdated="stats.lastUpdated" />
  </div>
</template>

<script>
import HeaderBar from './HeaderBar.vue';
import KpiRow from './KpiRow.vue';
import LineChart from './charts/LineChart.vue';
import PieChart from './charts/PieChart.vue';
import ChartCardWrapper from './charts/ChartCardWrapper.vue';
import SourcesList from './SourcesList.vue';
import RecentLeadsTable from './RecentLeadsTable.vue';
import FooterBar from './FooterBar.vue';
import { getDashboardStats, getRecentLeads } from './utils/api';
import { formatNumber } from './utils/helpers';

export default {
  name: 'Statistic',
  props: ['statistic', 'requests'],
  components: { HeaderBar, KpiRow, LineChart, PieChart, ChartCardWrapper, SourcesList, RecentLeadsTable, FooterBar },
  data() {
    return {
      stats: {
        totalLeads: 0,
        leadsToday: 0,
        visitsToday: 0,
        conversionRate: 0,
        avgTimeToContact: 0,
        leadsDelta: 0,
        avgLeadsPerDay: 0,
        lastUpdated: null,
        sources: []
      },
      leadsSeries: [],
      recentLeads: [],

      currentStatistic: null,
      currentRange: null,
      ranges: [
        {
          key: 'today',
          title: 'Сегодня'
        },
        {
          key: 'last_7_days',
          title: 'За 7 дней'
        },
        {
          key: 'current_week',
          title: 'За неделю'
        },
        {
          key: 'current_month',
          title: 'За месяц'
        },
        {
          key: 'last_90_days',
          title: 'За 90 дней'
        },
        {
          key: 'current_year',
          title: 'За год'
        },
        {
          key: 'all_time',
          title: 'За все время'
        }
      ],
    };
  },
  computed: {
    peakLabel() {
      if (!this.leadsSeries || !this.leadsSeries.length) return '-';
      const peak = this.leadsSeries.reduce((a, b) => (b.value > a.value ? b : a), this.leadsSeries[0]);
      return `${peak.label} (${peak.value})`;
    }
  },
  methods: {
    formatNumber,
    getRangeTitle (key) {
      return this.ranges.find(item => item.key == key)?.title
    },
    async fetchAll() {

      try {
        const [stats, leads] = await Promise.all([getDashboardStats(this.range), getRecentLeads(this.range)]);

        this.stats = { ...this.stats, ...stats };
        this.leadsSeries = stats.series || [];
        this.recentLeads = leads || [];
      } catch (e) {
        console.error('fetchAll error', e);
      }
      
    },
    refresh() {
      this.fetchAll();
    },
    onChangeRange(newRange) {
      this.range = newRange;
      this.currentStatistic = this.statistic[newRange]
      this.currentRange = newRange
      this.fetchAll();
    },
    onPointClick(point) {
      // пример: фильтрация таблицы по дате
      const label = point && point.label;
      if (label) {
        // показать только заявки за этот день
        this.recentLeads = this.recentLeads.filter(l => l._dayLabel === label || true); // placeholder
      }
    },
    openLead(id) {
      // место для навигации или открытия модалки
    }
  },
  watch: {
    statistic () {
      this.currentStatistic = this.statistic?.current_year
      this.currentRange = 'current_year'
    }
  },
  mounted() {
    this.currentStatistic = this.statistic?.current_year
    this.currentRange = 'current_year'
    this.fetchAll();
  }
};
</script>

<style scoped>
.admin-dashboard{
  display:flex;
  flex-direction:column;
  gap:1rem;
  padding:1rem; 
  width: 100%;
  overflow: hidden;
}
.charts{display:flex;gap:1rem;flex-wrap:nowrap; flex-direction: row}
.chart-meta{
  display:flex;
  gap:1rem;
}
.admin-dashboard__container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
@media (max-width:900px){.charts{flex-direction:column}}
</style>